import React from 'react';
import {ShiftSchedule} from '@gakki/api/types';
import {CustomIconButton} from '@common/components/Button';
import InfoTip, {P} from '@gakki/components/info-tip/info-tip';
import cx from 'classnames';
import {ReactComponent as Warning} from '@gakki/assets/warning.svg';

type ShiftScheduleItemProps = {
  item: ShiftSchedule;
  idx: number;
  onEdit: (data: ShiftSchedule) => void;
  onRemove: (id: string) => void;
  disabled?: boolean;
  deletable?: boolean;
  error?: boolean;
};
function ShiftScheduleItem({
  item,
  idx,
  onEdit,
  onRemove,
  disabled = false,
  deletable = true,
  error = false,
}: ShiftScheduleItemProps) {
  return (
    <fieldset
      className={
        cx('grid grid-cols-[55px,1fr] w-full py-5 pr-4 pl-0 text-[15px] border-b border-b-[#d5dadd]', {
          'bg-[#FAEFEF]': error,
        })
      }
      data-test-id={`shift-schedule-${idx}`}
    >
      <h5
        className={
          'm-0 justify-self-center col-start-1 col-end-2 row-start-1 row-end-4'
        }
      >
        {(idx + 1).toString().padStart(2, '0')}
      </h5>
      <div className="flex flex-col">
        <h4
          className={
            'text-[15px] flex justify-between items-center border-b border-b-[#d4d9dc] pb-[5px] mb-2'
          }
        >
          <div className="flex items-center">
            <span
              className={'w-5 h-5 rounded-[50%] mr-[10px] inline-block '}
              style={{
                backgroundColor: item.color,
              }}
              data-test-id={'color'}
            />
            <span data-test-id={'name'}>{item.name}</span>
          </div>
          <div className={'flex items-center justify-center'}>
            {error && (
              <div className="px-[6px]">
                <InfoTip
                  customIcon={<span className="text-[#be3a3a] text-[14px]"><Warning /></span>}
                  info={
                    <section className="w-50">
                      資料未正確，請點擊編輯後，修正紅色提示字欄位內容。
                    </section>
                  }
                />
              </div>
            )}
            {
              deletable &&
              <CustomIconButton
                onClick={() => onRemove(item.id)}
                disabled={disabled}
                data-test-id={'remove-btn'}
                icon="trash"
              />
            }
            <CustomIconButton
              onClick={() => onEdit(item)}
              data-test-id={'edit-btn'}
              icon="edit"
            />
          </div>
        </h4>
        <div
          className={
            'grid grid-cols-[auto,auto,auto,1fr] gap-y-2 gap-x-[25px] mb-0'
          }
        >
          <span>上班時間</span>
          <span data-test-id={'start-working-time'}>
            {item.startWorkingTime}
          </span>
          <span>下班時間 </span>
          <span data-test-id={'off-working-time'}>{item.offWorkingTime} </span>
          <span>日切換時間 </span>
          <span data-test-id={'day-start-time'}>{item.dayStartTime}</span>
          <span
            className={
              'col-start-1 col-end-2 2xl:col-start-auto 2xl:col-end-auto'
            }
          >
            休息時間
          </span>
          <div
            className={
              'col-start-2 col-end-4 2xl:col-start-auto 2xl:col-end-auto'
            }
          >
            {item.restTimes.map((rest, restIdx) => {
              return (
                <div key={`rest_time_${restIdx}`}>
                  <span data-test-id={`rest-start-time-${restIdx}`}>
                    {rest.startTime}
                  </span>{' '}
                  ~{' '}
                  <span data-test-id={`rest-end-time-${restIdx}`}>
                    {rest.endTime}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </fieldset>
  );
}

export default ShiftScheduleItem;
